module.exports = __webpack_public_path__ + "static/media/system-oto-modulesB-bg.964334d3.png";